import { Link } from "@tanstack/react-router";
import { Phone, Mail, MapPin, Clock, Facebook, ExternalLink } from "lucide-react";
import { srcSetFor } from "@/lib/responsive";
import logo from "@/assets/logo.png";
import ProtectedEmail from "@/components/ProtectedEmail";

const Footer = () => {
  return (
    <footer className="bg-secondary text-secondary-foreground footer-shine relative">
      <div className="container mx-auto px-4 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div>
            <img src={logo} srcSet={srcSetFor(logo)} sizes="300px" alt="JTB Floors" width={1536} height={1024} decoding="async" className="h-36 w-auto mb-4" />
            <p className="text-secondary-foreground/70 text-sm leading-relaxed">
              35 years of expert flooring installation. Hardwood, ceramic, laminate, hard tile & marble. Residential & commercial.
            </p>
            <p className="mt-4 text-xs text-secondary-foreground/50">
              100% satisfaction guarantee on all labor
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading font-semibold mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="tel:17739342004" className="flex items-center gap-2 hover:text-primary transition-colors">
                  <Phone className="w-4 h-4 text-primary" />
                  (773) 934-2004
                </a>
              </li>
              <li>
                <ProtectedEmail className="flex items-center gap-2 hover:text-primary transition-colors">
                  <Mail className="w-4 h-4 text-primary" />
                </ProtectedEmail>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-primary mt-0.5" />
                2313 Evergreen Ave, Fox River Grove, IL 60021
              </li>
              <li className="flex items-center gap-2">
                <Clock className="w-4 h-4 text-primary" />
                Mon–Fri 8AM–6PM
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-primary transition-colors">Home</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-colors">Services</Link></li>
              <li><Link to="/our-work" className="hover:text-primary transition-colors">Our Work</Link></li>
              <li><Link to="/about" className="hover:text-primary transition-colors">About</Link></li>
              <li><Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Social / External */}
          <div>
            <h3 className="font-heading font-semibold mb-4">Find Us</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="https://www.facebook.com/profile.php?id=100064015626425#" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-primary transition-colors">
                  <Facebook className="w-4 h-4 text-primary" /> Facebook
                </a>
              </li>
              <li>
                <a href="https://maps.app.goo.gl/Tbt848wzbXLTv6nb7" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-primary transition-colors">
                  <MapPin className="w-4 h-4 text-primary" /> Google Maps
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-foreground/10 text-center text-xs text-secondary-foreground/50">
          © {new Date().getFullYear()} JTB Floors. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
